import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectbookingdetails, bookingdetails, selectDetailsLoading } from "./HotelSlice";
import { selectCurrentUser } from "../auth/authSlice";
import { toast } from 'react-hot-toast';
import { CheckCircle, Clock, XCircle } from 'lucide-react';
import CancellationPolicyPopup from "./CancellationPolicyPopup";
import BookingReviewShimmer from './BookingReviewShimmer';
import { getapiKey, getbaseURL } from "../../api/axios";
import ReviewBooking from './ReviewBooking';
const PaymentConfirm = () => {
    const [showCancellationPopup, setShowCancellationPopup] = useState(true);
    const user = useSelector(selectCurrentUser)
    const selectbookingdetailsData = useSelector(selectbookingdetails)
    const DetailsLoading = useSelector(selectDetailsLoading)
    const location = useLocation();
    const dispatch = useDispatch();
    const [BookingId, setBookingId] = useState([]);

    // status can arrive either as a boolean at the top level (e.g. { status: true, message: "success" })
    // or as a nested object (e.g. { status: { success: true } }). Handle both shapes.
    const rawStatus = selectbookingdetailsData?.status
    const isSuccess = typeof rawStatus === "boolean" ? rawStatus === true : rawStatus?.success === true
    const apiErrorMessage = typeof rawStatus === "boolean"
        ? (rawStatus === false ? selectbookingdetailsData?.message : null)
        : (rawStatus?.success === false ? selectbookingdetailsData?.message : null)
    const HotelDetails = isSuccess ? selectbookingdetailsData?.HotelDetails : undefined
    // const searchQuery = isSuccess ? selectbookingdetailsData?.searchQuery?.searchQuery : undefined
    const RoomInfos = isSuccess ? selectbookingdetailsData?.RoomInfo : undefined
    const WalletBalance = isSuccess ? selectbookingdetailsData?.WalletBalance : undefined
    const fares = isSuccess ? selectbookingdetailsData?.fare : undefined
    const travellers = isSuccess ? selectbookingdetailsData?.travellers : undefined
    // Currency field is inconsistently named/cased across responses (currency / Currncy);
    // fall back through fare.symbol too, since that's reliably present.
    const CurrencySymbol =
        HotelDetails?.currency ||
        HotelDetails?.Currncy ||
        fares?.symbol ||
        "INR"
    const BookingStatus = (isSuccess && selectbookingdetailsData?.HotelDetails?.BookingStatus) || 0
    useEffect(() => {
        const parts = location.pathname.split("/").filter(Boolean);
        const bookingId = parts[parts.length - 1];
        setBookingId(bookingId)
        if (DetailsLoading && BookingStatus === 0) {
            setTimeout(() => {
                FetchBookingDetails({
                    FormData: {
                        BookingID: bookingId,
                    }
                });
            }, 1000);
        }

    }, [location.pathname, BookingStatus, DetailsLoading]);


    const FetchBookingDetails = async (payload) => {
        try { await dispatch(bookingdetails(payload)).unwrap(); }
        catch (err) { console.error("Fetch failed:", err); }
    };
    const calculatePaxCounts = (data) => {
        if (!data || !Array.isArray(data)) {
            return { adults: 0, children: 0, infants: 0 };
        }

        const counts = data.reduce((acc, roomGroup) => {
            if (roomGroup.Rooms && Array.isArray(roomGroup.Rooms)) {
                roomGroup.Rooms.forEach(room => {
                    acc.adults += room.Adult || 0;
                    acc.children += room.Child || 0;
                    acc.infants += room.Infant || 0;
                });
            }
            return acc;
        }, { adults: 0, children: 0, infants: 0 });

        return counts;
    };
    // const paxCounts = calculatePaxCounts(selectbookingdetailsData && selectbookingdetailsData.status.success && selectbookingdetailsData.RoomInfo);
    const paxCounts = calculatePaxCounts(
        selectbookingdetailsData?.data?.RoomInfo ||
        selectbookingdetailsData?.payload?.RoomInfo ||
        selectbookingdetailsData?.RoomInfo ||
        selectbookingdetailsData?.result?.RoomInfo
    );
    const ViewTicketDetails = () => {
        const url = `${getbaseURL()}/hotel/print-voucher/${BookingId}?token=${user.token}`
        window.open(url, '_blank');
    }


    return (
        <>
            {DetailsLoading ? (
                <>
                    <div className="p-4">
                        <BookingReviewShimmer />
                    </div>
                </>
            ) : apiErrorMessage ? (
                <div className="max-w-2xl mx-auto p-6">
                    <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-5">
                        <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                        <div>
                            <h2 className="text-red-700 font-semibold mb-1">Unable to load booking</h2>
                            <p className="text-red-600 text-sm">{apiErrorMessage}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <>

                    <div className="max-w-7xl mx-auto p-6 bg-gray-50 min-h-screen">
                        {/* Header Status */}
                        {/* <div className="flex flex-wrap items-center justify-between bg-white border border-gray-200 rounded-xl p-5 shadow-sm mb-6">
                            <div className="flex items-center gap-3">
                                {BookingStatus === 1 ? (
                                    <>
                                        <CheckCircle className="w-10 h-10 text-green-500" />
                                        <h2 className="text-xl font-semibold text-green-600">
                                            Booking Successful
                                        </h2>
                                    </>
                                ) : BookingStatus === 3 ? (
                                    <>
                                        <XCircle className="w-10 h-10 text-red-500" />
                                        <h2 className="text-xl font-semibold text-red-600">
                                            Booking Failed
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <Clock className="w-10 h-10 text-yellow-500" />
                                        <h2 className="text-xl font-semibold text-yellow-600">
                                            Booking Pending
                                        </h2>
                                    </>
                                )}
                            </div>

                            <button
                                onClick={ViewTicketDetails}
                                className={`px-6 py-2 font-semibold rounded-lg transition shadow-sm ${BookingStatus === 1
                                    ? "bg-green-600 text-white hover:bg-green-700"
                                    : BookingStatus === 3
                                        ? "bg-red-600 text-white hover:bg-red-700"
                                        : "bg-yellow-600 text-white hover:bg-yellow-700"
                                    }`}
                            >
                                View Voucher
                            </button>
                            <button className={`px-6 py-2 font-semibold rounded-lg transition shadow-sm bg-red-600 text-white hover:bg-red-700`}  >
                                Cancellation
                            </button>
                        </div> */}
                        {/* <ReviewBooking /> */}
                        <div className="flex flex-wrap items-center justify-between bg-white border border-gray-200 rounded-xl p-5 shadow-sm mb-6">
                            <div className="flex items-center gap-3">
                                {BookingStatus === 1 ? (
                                    <>
                                        <CheckCircle className="w-10 h-10 text-green-500" />
                                        <h2 className="text-xl font-semibold text-green-600">
                                            Booking Successful
                                        </h2>
                                    </>
                                ) : BookingStatus === 3 ? (
                                    <>
                                        <XCircle className="w-10 h-10 text-red-500" />
                                        <h2 className="text-xl font-semibold text-red-600">
                                            Booking Failed
                                        </h2>
                                    </>
                                ) : BookingStatus === 22 ? (
                                    <>
                                        <XCircle className="w-10 h-10 text-red-500" />
                                        <h2 className="text-xl font-semibold text-red-600">
                                            Booking Aborted
                                        </h2>
                                    </>
                                ) : (
                                    <>
                                        <Clock className="w-10 h-10 text-yellow-500" />
                                        <h2 className="text-xl font-semibold text-yellow-600">
                                            Booking Pending
                                        </h2>
                                    </>
                                )}
                            </div>

                            {/* Group buttons together */}
                            {BookingStatus === 1 && (
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={ViewTicketDetails}
                                        className={`px-6 py-2 font-semibold rounded-lg transition shadow-sm ${BookingStatus === 1
                                            ? "bg-green-600 text-white hover:bg-green-700"
                                            : BookingStatus === 3
                                                ? "bg-red-600 text-white hover:bg-red-700"
                                                : "bg-yellow-600 text-white hover:bg-yellow-700"
                                            }`}
                                    >
                                        View Voucher
                                    </button>
                                    {BookingStatus == 1 &&
                                        <a className="px-6 py-2 font-semibold rounded-lg transition shadow-sm bg-red-600 text-white hover:bg-red-700" href={`/hotel/ cancellation/${BookingId}`}>
                                            Cancellation
                                        </a>
                                    }
                                </div>
                            )}

                        </div>
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            {/* Left Column */}
                            <div className="lg:col-span-2 space-y-6">
                                {/* Hotel Details Card */}
                                <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                                    <h2 className="text-xl font-semibold text-gray-800 mb-1">
                                        {HotelDetails?.name}
                                    </h2>
                                    <p className="text-gray-600 text-sm mb-3">
                                        {HotelDetails?.ad?.adr}, {HotelDetails?.ad?.adr2}{" "}
                                        {HotelDetails?.ad?.postalCode}, {HotelDetails?.ad?.ctn},{" "}
                                        {HotelDetails?.ad?.cn}
                                    </p>

                                    {/* <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 text-sm rounded-lg px-4 py-3 mb-5">
                                        Please bear in mind that this property is 30.0 km from Delhi city
                                        center.
                                    </div> */}

                                    {/* Checkin/Checkout Grid */}
                                    <div className="grid grid-cols-2 gap-6 mb-5">
                                        <div>
                                            <h3 className="font-semibold text-gray-700 mb-2">CHECK IN</h3>
                                            <p className="text-gray-600">{HotelDetails?.checkinDate}</p>
                                            <p className="text-gray-600 text-sm">12 PM</p>
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-gray-700 mb-2">CHECK OUT</h3>
                                            <p className="text-gray-600">{HotelDetails?.checkoutDate}</p>
                                            <p className="text-gray-600 text-sm">11 AM</p>
                                        </div>
                                    </div>

                                    {/* Summary */}
                                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-5">
                                        <p className="text-gray-700 text-sm font-medium">
                                            {fares?.nightCoun} Nights | {paxCounts.adults} Adults,{" "}
                                            {paxCounts.children} Children | {fares?.roomCoun} Rooms
                                        </p>
                                    </div>

                                    {/* Room Details */}
                                    {RoomInfos?.[0]?.Rooms?.[0] && (() => {
                                        const roomGroup = RoomInfos[0];
                                        const room = roomGroup.Rooms[0];
                                        return (
                                            <div className="border border-gray-200 rounded-lg p-4 hover:shadow-sm transition">
                                                <h3 className="font-semibold text-gray-800 text-lg mb-1">
                                                    {room.RoomType}
                                                </h3>
                                                <p className="text-gray-600 text-sm mb-2">
                                                    {room.MealBase} •{" "}
                                                    {roomGroup.IsPan ? "PAN required" : "No PAN required"}
                                                </p>

                                                <div className="flex justify-between items-center border-t pt-3">
                                                    <p className="text-gray-600 text-sm">
                                                        {room.rooms || 1} Room(s) •{" "}
                                                        {room.nights || roomGroup.Nights || 1} Night(s)
                                                    </p>
                                                    <p className="font-semibold text-gray-900">
                                                        {CurrencySymbol}{" "}
                                                        {room.HotelRoomPrice * room.rooms ||
                                                            room.pernightperroomprice * room.rooms}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    })()}
                                </div>

                                {/* Hotel Description Card */}
                                <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                        Hotel Description
                                    </h3>
                                    {HotelDetails?.des?.filter((item) => item.key !== "Default" && typeof item.value === "string").length > 0 ? (
                                        HotelDetails.des
                                            .filter((item) => item.key !== "Default" && typeof item.value === "string")
                                            .map((item, index) => (
                                                <div key={index} className="mb-4">
                                                    <h4 className="font-medium text-gray-700 mb-1">{item.key}</h4>
                                                    <p className="text-gray-600 text-sm">{item.value}</p>
                                                </div>
                                            ))
                                    ) : (
                                        <p className="text-gray-500 text-sm">No details available</p>
                                    )}

                                    <p className="text-xs text-gray-500 italic border-t pt-3">
                                        <strong>Disclaimer:</strong> Amenities are subject to availability
                                        and may be chargeable as per hotel policy.
                                    </p>
                                </div>

                                {/* Guest Details Card */}
                                <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                        Primary Guest
                                    </h3>
                                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                                        <h4 className="font-semibold text-gray-800 mb-1">
                                            {travellers?.[0]?.[0]?.title} {travellers?.[0]?.[0]?.fname}{" "}
                                            {travellers?.[0]?.[0]?.lname}
                                        </h4>
                                        <p className="text-gray-600 text-sm">
                                            Mobile - +{travellers?.[0]?.[0]?.countrycode}
                                            {travellers?.[0]?.[0]?.mobile}
                                        </p>
                                        <p className="text-gray-600 text-sm">
                                            Email - {travellers?.[0]?.[0]?.email}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column - Fare Summary */}
                            <div className="lg:col-span-1">
                                <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm sticky top-6">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                        Fare Details
                                    </h3>
                                    <div className="space-y-3 mb-5 text-sm">
                                        <div className="flex justify-between text-gray-600">
                                            <span>
                                                {fares?.roomCoun} Room(s) x {fares?.nightCoun} Night(s)
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Base Fare</span>
                                            <span className="text-gray-800">
                                                {fares?.symbol} {fares?.BaseFare}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Hotel Taxes</span>
                                            <span className="text-gray-800">
                                                {fares?.symbol} {fares?.TaxesandFee}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Convenience Fee</span>
                                            <span className="text-gray-800">
                                                {fares?.symbol}{" "}
                                                {(fares?.FixedMarkUp || 0) + (fares?.GSTOnMarkUp || 0)}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Markup</span>
                                            <span className="text-gray-800">{fares?.symbol} {fares?.TotalAgentMarkup}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Discount</span>
                                            <span className="text-gray-800">{fares?.symbol} 0</span>
                                        </div>

                                        <div className="border-t border-gray-200 pt-3 flex justify-between font-medium">
                                            <span>Price after Discount</span>
                                            <span>
                                                {fares?.symbol} {fares?.GrandTotal + fares?.TotalAgentMarkup}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="border-t border-gray-300 pt-4 flex justify-between items-center">
                                        <span className="text-base font-semibold text-gray-800">
                                            Total Amount
                                        </span>
                                        <span className="text-lg font-bold text-gray-900">
                                            {fares?.symbol} {fares?.GrandTotal + fares?.TotalAgentMarkup}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}


            {/* <div className="max-w-7xl mx-auto p-6 bg-white">
                <h1 className="text-2xl font-bold text-gray-800 mb-6">Payment</h1>
                {
                    <span className="grid grid-cols-3 items-center w-full gap-4">
                        <div className="flex items-center gap-4 justify-self-start">
                            {BookingStatus === 1 ? (
                                <>
                                    <CheckCircle className="w-16 h-16 text-green-500" />
                                    <h2 className="text-xl font-bold text-green-600">
                                        Booking Successful
                                    </h2>
                                </>
                            ) : BookingStatus === 3 ? (
                                <>
                                    <XCircle className="w-16 h-16 text-red-500" />
                                    <h2 className="text-xl font-bold text-red-600">
                                        Booking Failed
                                    </h2>
                                </>
                            ) : (

                                <>
                                    <Clock className="w-16 h-16 text-yellow-500" />
                                    <h2 className="text-xl font-bold text-yellow-600">
                                        Booking Pending
                                    </h2>
                                </>
                            )}
                        </div>
                        <button
                            onClick={ViewTicketDetails}
                            className={`font-semibold px-6 py-2 rounded-lg shadow transition justify-self-center ${BookingStatus === 1
                                ? "bg-green-600 text-white hover:bg-green-700"
                                : BookingStatus === 3
                                    ? "bg-red-600 text-white hover:bg-red-700"
                                    : "bg-yellow-600 text-white hover:bg-yellow-700"
                                }`}
                        >
                            View Voucher
                        </button>
                        <div></div>
                    </span>
                }
                <div className="flex gap-6">
                    <div className="flex-1 space-y-6">
                        <div className="border border-gray-200 rounded-lg p-6">
                            <h2 className="text-xl font-semibold text-gray-800 mb-2">{HotelDetails && HotelDetails.name}</h2>
                            <p className="text-gray-600 mb-1">  {HotelDetails && HotelDetails?.ad?.adr},  {HotelDetails && HotelDetails?.ad?.adr2} {HotelDetails && HotelDetails?.ad?.postalCode},{HotelDetails && HotelDetails?.ad?.ctn}, {HotelDetails && HotelDetails?.ad?.cn}</p>
                           

                            <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4">
                                <p className="text-yellow-700 text-sm">
                                    Please bear in mind that this property is 30.0 km from Delhi city center.
                                </p>
                            </div>
                            <div className="grid grid-cols-2 gap-6 mb-6">
                                <div>
                                    <h3 className="font-semibold text-gray-700 mb-2">CHECK IN</h3>
                                    <p className="text-gray-600">{HotelDetails && HotelDetails.checkinDate}</p>
                                    <p className="text-gray-600">12 PM</p>
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-700 mb-2">CHECK OUT</h3>
                                    <p className="text-gray-600">{HotelDetails && HotelDetails.checkoutDate}</p>
                                    <p className="text-gray-600">11 AM</p>
                                </div>
                            </div>
                            <div className="bg-gray-50 rounded p-4 mb-6">
                                <p className="text-gray-700 font-medium">
                                    {fares && fares.nightCoun} Nights | {paxCounts.adults} Adults, {paxCounts.children} Children | {fares && fares.roomCoun} Rooms
                                </p>
                            </div>


                            {RoomInfos && RoomInfos.length > 0 && RoomInfos[0].Rooms[0] && (() => {
                                const roomGroup = RoomInfos[0];
                                const room = roomGroup.Rooms[0];

                                return (
                                    <div className={`flex gap-4 p-4 border rounded-lg cursor-pointer transition-all duration-200 border-gray-200 hover:border-gray-400`}>

                                        <div className="flex-1">
                                            <div className="mb-2">
                                                <h3 className="font-semibold text-lg">{room.RoomType}</h3>
                                                <p className="text-gray-600 text-sm">
                                                    {room.MealBase} • {roomGroup.IsPan ? "PAN required" : "No PAN required"}
                                                </p>
                                            </div>

                                            <div className="flex flex-wrap gap-4 mb-3">
                                                {room.Extrabenefits && room.Extrabenefits.map((benefit, benefitIdx) => (
                                                    <div key={benefitIdx} className="flex items-center text-green-600 text-sm">
                                                        <i className="fas fa-check mr-1"></i>
                                                        <span>{benefit}</span>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="flex justify-between items-center pt-3 border-t border-gray-200">
                                                <div className="text-sm text-gray-600">
                                                    <span>{room.rooms || 1} Room(s)</span>
                                                    <span className="mx-2">•</span>
                                                    <span>{room.nights || roomGroup.Nights || 1} Night(s)</span>
                                                </div>

                                                <div className="flex items-center gap-4">
                                                    <div className="text-right">
                                                        <p className="font-semibold text-lg">{CurrencySymbol} {room.HotelRoomPrice * room.rooms || room.pernightperroomprice * room.rooms}</p>
                                                        
                                                        {showCancellationPopup && roomGroup && (
                                                            <CancellationPolicyPopup
                                                                cancellationData={roomGroup.CancelArr}
                                                                currencySymbol={CurrencySymbol}
                                                                onClose={() => setShowCancellationPopup(false)}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}
                        </div>
                        <div className="border border-gray-200 rounded-lg p-6">
                            <h3 className="font-semibold text-gray-800 mb-4">Hotel Decription</h3>

                            {HotelDetails && HotelDetails.des && HotelDetails.des.filter((item) => item.key !== "Default" && typeof item.value === "string").length > 0 ? (
                                HotelDetails.des
                                    .filter((item) => item.key !== "Default" && typeof item.value === "string")
                                    .map((item, index) => (
                                        <div key={index} className="mb-4">
                                            <h4 className="font-medium text-gray-700 mb-2">{item.key}</h4>
                                            <p className="text-gray-600">{item.value}</p>
                                        </div>
                                    ))
                            ) : (
                                <p className="text-gray-500">No details available</p>
                            )}


                            <div className="border-t border-gray-200 pt-4 mb-6">
                                <p className="text-gray-500 text-xs italic">
                                    <strong>Disclaimer notification:</strong> Amenities are subject to availability and may be chargeable as per the hotel policy.
                                </p>
                            </div>
                        </div>

                        <div className="border border-gray-200 rounded-lg p-6">


                            <div className="border-t border-gray-200 pt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <h3 className="text-lg font-semibold text-gray-800">Primary Guest</h3>
                                </div>

                                <div className="bg-gray-50 rounded-lg p-4">
                                    <h4 className="font-semibold text-gray-800 mb-2">{travellers && travellers[0][0].title} {travellers && travellers[0][0].fname} {travellers && travellers[0][0].lname} </h4>
                                    <p className="text-gray-600 text-sm">Mobile - +{travellers && travellers[0][0].countrycode}{travellers && travellers[0][0].mobile}</p>
                                    <p className="text-gray-600 text-sm">Email - {travellers && travellers[0][0].email}</p>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="w-96">
                        <div className="sticky top-6 border border-gray-200 rounded-lg p-6">
                            <h3 className="font-semibold text-gray-800 mb-4">Fare Details</h3>

                            <div className="space-y-3 mb-4">
                                <div className="flex justify-between">
                                    <span className="text-gray-600">{fares && fares.roomCoun} Room(s) x {fares && fares.nightCoun} Night(s)</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Base Fare</span>
                                    <span className="text-gray-800">{fares && fares.symbol} {fares && fares.BaseFare}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Hotel Taxes</span>
                                    <span className="text-gray-800">{fares && fares.symbol} {fares && fares.TaxesandFee}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Convenience Fee</span>
                                    <span className="text-gray-800">{fares && fares.symbol} {((fares && fares.FixedMarkUp) + (fares && fares.GSTOnMarkUp))}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Discount</span>
                                    <span className="text-gray-800">{fares && fares.symbol} 0 </span>
                                </div>
                                <div className="flex justify-between border-t border-gray-200 pt-3">
                                    <span className="text-gray-600 font-medium">Price after Discount</span>
                                    <span className="text-gray-800 font-medium">{fares && fares.symbol} {fares && fares.GrandTotal}</span>
                                </div>
                            </div>
                            <div className="flex justify-between items-center border-t border-gray-300 pt-4">
                                <span className="text-lg font-semibold text-gray-800">Total Amount</span>
                                <span className="text-lg font-bold text-gray-800">{fares && fares.symbol} {fares && fares.GrandTotal}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default PaymentConfirm;